<template>
    <li class="friend"
        :class="{ deletedByUser: !!f.deletedByUser }">
        <ul v-if="f.deleted"
            class="buttons">
            <li>
                <Btn size="sm"
                     color="danger"
                     :loading="forgetting"
                     @click="forget">
                    <i class="glyphicon glyphicon-trash"></i>
                    Forget
                </Btn>
            </li>

            <li v-if="!f.deactivated">
                <Btn v-if="f.deletedByUser"
                     size="sm"
                     color="primary"
                     :loading="settingDeletedByUser"
                     @click="setDeletedByUser(false)">
                    <i class="glyphicon glyphicon-arrow-left"></i>
                    Remove from "People I Deleted"
                </Btn>
                <Btn v-else
                     size="sm"
                     color="primary"
                     :loading="settingDeletedByUser"
                     @click="setDeletedByUser(true)">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                    Move to "People I Deleted"
                </Btn>
            </li>
        </ul>

        <a :href="profileUrl"
           rel="noopener noreferrer"
           target="_blank">
            <FriendPicture :src="pictureUrl" />
        </a>
        <p>
            <span class="name">
                <a :href="profileUrl"
                   rel="noopener noreferrer"
                   target="_blank">{{ f.name }}</a>
            </span>

            <span class="date">
                <span v-if="f.deactivated"
                      class="label label-warning">Deactivated</span>
                <span v-else-if="f.deleted && f.deletedByUser"
                      class="label label-default">You Deleted</span>
                <span v-else-if="f.deleted && !f.deletedByUser"
                      class="label label-danger">Deleted You</span>
                <span v-else
                      class="label label-success">Friends</span>

                Last seen as your friend on {{ lastSeen }}
            </span>
        </p>
    </li>
</template>

<script>
import Btn from '@/app/components/Btn';
import { format } from 'date-fns';
import { sendBackendRequest } from '@/app/lib/Messaging/requests';
import RequestType from 'wdm-common/Messaging/RequestType';
import FriendPicture from '@/app/pages/friends/FriendPicture';

export default {

    components: {
        FriendPicture,
        Btn,
    },

    props: {
        friend: {
            type: Object,
            required: true,
        },
    },
    emits: [
        'forgotten',
    ],

    data() {
        return {
            settingDeletedByUser: false,
            forgetting: false,
            f: this.friend,
        };
    },

    computed: {
        profileUrl() {
            if (new RegExp(/\D/).test(this.f.friendId)) {
                // ID contains non-numeric characters
                return 'https://www.facebook.com/' + this.f.friendId;
            }

            return 'https://www.facebook.com/profile.php?id=' + this.f.friendId;
        },

        pictureUrl() {
            if (this.f.pictureUrl) {
                return this.f.pictureUrl;
            }

            return null;
        },

        lastSeen() {
            return format(new Date(this.f.lastSeen), 'LLLL do y');
        },
    },

    methods: {
        forget() {
            this.forgetting = true;

            if (!window.confirm("We'll forget this person was ever your friend and won't show them here anymore. This cannot be undone, but they will reappear if you become friends with them again.\nAre you sure you want to do this?")) {
                return;
            }

            sendBackendRequest(
                RequestType.FORGET_FRIEND,
                {
                    userId: this.f.userId,
                    friendId: this.f.friendId,
                }
            )
                .then(() => {
                    this.$emit('forgotten', this.f);
                })
                .finally(() => {
                    this.forgetting = false;
                });
        },

        setDeletedByUser(value) {
            this.settingDeletedByUser = true;
            sendBackendRequest(
                RequestType.SET_FRIEND_DELETED_BY_USER,
                {
                    userId: this.f.userId,
                    friendId: this.f.friendId,
                    value,
                }
            )
                .then((response) => {
                    console.log('response', response);
                    this.f = response.friend;
                })
                .finally(() => {
                    this.settingDeletedByUser = false;
                });
        },
    },
};
</script>
